<div class="container ">
    <div class="w-full text-center">
        <div class="heading-sub">Statistics</div>
        <p class="subheading">
            Fastest growing car leasing company in India
        </p>
      </div>
    <div class="tw-flex tw-basis-1/3 tw-items-center tw-gap-0 md:tw-mx-20">
        <div class="box">
            <div class="content">
                <div class="stats-label">
                    Fleet Size
                </div>
                <div class="stats">
                    750+
                </div>
            </div>
            <img src="../assets/images/landing-page/stats1.svg" class="stats-image">
        </div>
    
        <div class="box box2">
            <div class="content">
                <div class="stats-label">
                    Our Service Network is available 
                </div>
                <div class="stats">
                    All Over India
                </div>
            </div>
            <img src="../assets/images/landing-page/stats2.svg" class="stats-image-mid">
    
        </div>
    
        <div class="box">
            <div class="content">
                <div class="stats-label">
                Asset Under Management (AUM)
            </div>
            <div class="stats">
                40+ CR
            </div>
            </div>
            <img src="../assets/images/landing-page/stats3.svg" class="stats-image">
    
        </div>
    </div>
    
</div>